import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'

import { 
  getCourseRecord, fetchCourseRecord, downloadCourseSyllabus
} from '../../../store/client'

import CourseDetailView from '../views/CourseDetailView'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import Button from '../../../shared/ui/Button'
import Link from '../../../shared/ui/Link'

import { withStyles } from '@material-ui/core/styles'
import LinearProgress from '@material-ui/core/LinearProgress'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'

import BackIcon from '@material-ui/icons/ArrowBackIos'

const styles = theme => ({
  root: {
    position: 'relative',
    padding: theme.spacing(2)
  },
  linearProgress: {
    top: 0,
    left: 0,
    position: 'absolute',
    height: '2px',
    overflow: 'hidden',
    width: '100%',
    zIndex: 10
  },
  navigationPanel: {
    //padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
    width: '100%'
  },
  sectionTitle: {
    fontSize: theme.typography.h5.fontSize,
    fontWeight: 800,
    //color: theme.palette.primary.main
  },
  sectionSubtitle: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: 800
  },  
})


const NavigationPanel = ({ theme, classes, course, openLink }) => {
  return (
    <div elevation={2}
      className={classes.navigationPanel}    
      >
      <Box display='flex' justifyContent='flex-start' alignItems='center'>
        <Box display='flex' flexGrow={1} alignItems='center'>
          {/*
          <BrowseIcon style={{ color: 'grey' }} />
          &nbsp;
          <Button onClick={() => openLink(`/`)}>
            All Categories
          </Button>
          <RightIcon style={{ color: 'grey' }} />
          <Button onClick={() => openLink(`/course/`+course.category.key)}>
            { course.category_name }
          </Button>
          */}
          
          { course.category && course.category.key != 'default' ?
            <Button 
              icon={BackIcon}
              component={Link}
              to={`/browse/${course.category.key}`}
              >
              { course.category_name } Courses
            </Button>
          :
            <Button 
              icon={BackIcon}
              component={Link}
              to="/"
              >
              All Courses
            </Button>
          }
          
        </Box>
        <Box display='flex'>
        </Box>
      </Box>
    </div>
  )
}


const CourseDetailController = ({ theme, classes, ...props }) => {

  const { courseKey, isFetching, lastFetched, selectedDate, data } = props
  
  const navigationContext = useContext(NavigationContext)

  useEffect(() => {
    // CourseDetailView will start all the fetching.
  }, [])  
      
  return (
    <div className={classes.root}
      >      
      { false && isFetching &&
        <div className={classes.linearProgress}>
          <LinearProgress />
        </div>
      }      
      
      <Container maxWidth='lg'>
        <Box mt={0}>
          <NavigationPanel theme={theme} classes={classes} course={data}
          openLink={(link) => navigationContext.openLink(link)}
            />
        </Box>
        <Box mt={4}>
          <CourseDetailView
            courseKey={courseKey}
            selectedDate={selectedDate}
            />          
        </Box>
        <Box mt={10} />
      </Container>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  let courseKey = ownProps.match.params.courseKey

  let selectedDate = null

  if (ownProps.location && ownProps.location.search !== undefined)
    selectedDate = new URLSearchParams(ownProps.location.search).get('date') || null

  return {
    courseKey,
    ...getCourseRecord(state, courseKey),
    selectedDate: selectedDate
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  let courseKey = ownProps.match.params.courseKey
  
  return {
    fetchCourse: () => {
      dispatch(fetchCourseRecord(courseKey))
    },
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(CourseDetailController)
)
